module.exports = __webpack_public_path__ + "static/404_img@2x-d5c2efbce827d073296c8dc8452f5229.png";